<template>
  <div class="car-items">
    <div class="" v-for="(section, index) in sections"
         :key="section.serviceId"
         @click="toggleSection(section)">

      <!-- additional services -->
      <div class="car-item" :class="{'car-disabled': isDisabled}" v-if="displayAll && isOptional(section)">
        <checkbox :is-selected="section.selected" :is-disabled="isDisabled" :label="section.serviceName" />
        <span class="car-price" v-if="!hidePrices">{{section.actualGrossRate + section.actualSurchargeGrossRate | currency}}</span>
      </div>

      <!-- booking details -->
      <div class="car-item" :data-js="'service-item--' + index" :class="{'car-disabled': isDisabled}" v-else-if="!displayAll && section.selected">
        <span class="car-text">{{section.serviceName}}</span>
        <span class="car-price" v-if="!hidePrices">{{section.actualGrossRate + section.actualSurchargeGrossRate | currency}}</span>
        <span class="car-icon-remove" v-if="!hideRemoveIcon && isOptional(section)" />
      </div>

      <!-- cart -->
      <div class="car-item" :class="{'car-disabled': isDisabled || !isOptional(section)}" v-else-if="displayAll">
        <span class="car-text">{{section.serviceName}}</span>
        <span class="car-price" v-if="!hidePrices">{{section.actualGrossRate + section.actualSurchargeGrossRate | currency}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import bookingSectionService from '@/services/bookingSectionService';
import { find } from 'lodash';
import Checkbox from '@/components/Checkbox';

export default {
  name: 'OfferServiceSelection',
  data: function () {
    return {
      loading: false
    }
  },
  props: {
    allSections: {
      required: true
    },
    displayAll: {
      default: true
    },
    setLoading: {
      default: null
    },
    sections: {
      required: 'required'
    },
    payloadkey: {
      default: null
    },
    dispatchPath: {
      default: null
    },
    isDisabled: {
      default: false
    },
    hideRemoveIcon: {
      default: false
    },
    hidePrices: {
      type: Boolean,
      default: false
    },
    hideSectionLabel: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    isOptional(section) {
      return section.serviceType === 'ADDITIONAL' || section.optional;
    },
    toggleSection(section) {
      if (!this.isOptional(section) || this.isDisabled) {
        return;
      }
      section.selected = !section.selected;
      let selectedSection = find(this.allSections, ['serviceId', section.serviceId]);
      selectedSection.selected = section.selected;
      let payload = {
        key: this.payloadkey,
        selectedServiceIds: bookingSectionService.getSelectedServiceIds(this.allSections)
      };
      this.setLoading(true);
      this.$store.dispatch(this.dispatchPath, payload)
        .finally(() => {
          this.setLoading(false);
        });
    }
  },
  components: {
    Checkbox
  }
};
</script>
